import React from 'react';
import { NavLink } from 'react-router-dom';

class AboutCompany extends React.Component {
    render() {
        return (
            <>
                <div className="section-full p-t80 bg-white">
                    <div className="container">
                        <div className="section-content ">
                            <div className="m-service-containt text-black">
                                <div className="row">
                                    <div className="col-md-5 col-sm-12">
                                        <div className="service-about-left">
                                            <div className="mt-media">
                                                <img src={require('./../../images/s-1.png')} alt=""/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-7 col-sm-12">
                                        <div className="service-about-right m-b30">
                                            <h3 className="m-t0">In our work we have pride, quality is what we provide.</h3>
                                            <p>At Trivik Builders, we believe in the power of teamwork and interdisciplinary collaboration as the driving force behind insight and excellence in our work. Our team of committed professionals is dedicated to delivering quality in everything we do, aiming to exceed expectations. We uphold integrity by maintaining the highest ethical standards, demonstrating honesty and fairness in every decision. With agility, we respond swiftly to meet our clients’ needs, ensuring timely and effective solutions. We act with courage, making decisions in the best interests of our clients, even when faced with challenges. Above all, we value respect and trust, treating our clients and each other with dignity at all times, building lasting relationships based on mutual understanding.</p>
                                            <div className="call-for-quote-outer">
                                                <div className="call-quote">
                                                    <span>Call For a Quote:</span>
                                                    <a className="call-link-for-service" href="tel:+1(860) 682-0175"> +1(860) 682-0175</a>
                                                    
                                                </div>
                                                <div className="call-estimate bg-dark">
                                                <NavLink to={"/contactus"} className="site-button-secondry btn-effect"> For Inquiries</NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default AboutCompany;